document.addEventListener('click', async event => {
	const button = event.target.closest('section.annahme [data-copy]');
	if (!button) return;

	const lines = [];
	let headline = '';
	button.form.querySelectorAll('h2, .line:not(.button)').forEach(row => {
		if (row.tagName === 'H2') {
			headline = row.textContent.trim();
			return;
		}
		const field = row.querySelector('input, textarea');
		if (!field) return;
		if (field.type === 'checkbox' ? !field.checked : field.value.trim() === '') return;
		if (headline) {
			lines.push('\n' + headline);
			headline = '';
		}
		lines.push(field.type === 'checkbox' ? field.name : field.name + ': ' + field.value.trim());
	});

	try {
		await navigator.clipboard.writeText(lines.join('\n').trim());
		button.textContent = 'Kopiert!';
		setTimeout(() => { button.textContent = 'Kopieren'; }, 2000);
	} catch (error) {
		alert('Kopieren war nicht möglich. Bitte die Zwischenablage im Browser erlauben.');
	}
});
